import React from 'react';
import PropTypes from 'prop-types';
import { startCase, toLower } from 'lodash';

import ModalWithToggleButton from './modal-with-toggle-button';
import ProviderSurgeIncentiveEditForm from './provider-surge-incentive-edit-form-container';
import SurgeIncentive from '../interfaces/surge-incentive-interface';

const ProviderSurgeIncentiveEdit = ({
  surgeIncentiveStatus,
  surgeIncentive,
  reset,
  shouldCloseModal
}) => (
  <ModalWithToggleButton
    title={`Edit Surge Incentive (${startCase(toLower(surgeIncentiveStatus))})`}
    buttonProps={{
      text: 'Edit'
    }}
    onClose={reset}
    shouldCloseModal={shouldCloseModal}
  >
    <ProviderSurgeIncentiveEditForm
      surgeIncentiveStatus={surgeIncentiveStatus}
      surgeIncentive={surgeIncentive}
    />
  </ModalWithToggleButton>
);

ProviderSurgeIncentiveEdit.propTypes = {
  surgeIncentiveStatus: PropTypes.string.isRequired,
  surgeIncentive: SurgeIncentive,
  reset: PropTypes.func.isRequired,
  shouldCloseModal: PropTypes.bool.isRequired
};

export default ProviderSurgeIncentiveEdit;
